import React from 'react'
import { SiMastercard, SiStyledcomponents, SiVisa } from 'react-icons/si'
import styles from './Footer.module.scss'

const Footer: React.FC = () => {
  return (
    <>
      <div className={styles.parent}>
        <div className={styles.flexboxContainer}>
          <ul>
            <li>
              <svg
                xmlns='http://www.w3.org/2000/svg'
                viewBox='-10 -5 100 100'
                width='70px'
                height='50px'
                fill='none'
              >
                <path
                  d='M0 23.04C0 12.1788 0 6.74826 3.37413 3.37413C6.74826 0 12.1788 0 23.04 0H24.96C35.8212 0 41.2517 0 44.6259 3.37413C48 6.74826 48 12.1788 48 23.04V24.96C48 35.8212 48 41.2517 44.6259 44.6259C41.2517 48 35.8212 48 24.96 48H23.04C12.1788 48 6.74826 48 3.37413 44.6259C0 41.2517 0 35.8212 0 24.96V23.04Z'
                  fill='black'
                />
                <path
                  d='M25.54 34.5801C14.6 34.5801 8.3601 27.0801 8.1001 14.6001H13.5801C13.7601 23.7601 17.8 27.6401 21 28.4401V14.6001H26.1602V22.5001C29.3202 22.1601 32.6398 18.5601 33.7598 14.6001H38.9199C38.0599 19.4801 34.4599 23.0801 31.8999 24.5601C34.4599 25.7601 38.5601 28.9001 40.1201 34.5801H34.4399C33.2199 30.7801 30.1802 27.8401 26.1602 27.4401V34.5801H25.54Z'
                  fill='white'
                />
              </svg>
            </li>
            <li>
              <svg
                xmlns='http://www.w3.org/2000/svg'
                fill='none'
                viewBox='-10 -10 100 100'
                width='70px'
                height='50px'
              >
                <path
                  d='M25,2c12.703,0,23,10.297,23,23S37.703,48,25,48S2,37.703,2,25S12.297,2,25,2z M32.934,34.375 c0.423-1.298,2.405-14.234,2.65-16.783c0.074-0.772-0.17-1.285-0.648-1.514c-0.578-0.278-1.434-0.139-2.427,0.219 c-1.362,0.491-18.774,7.884-19.78,8.312c-0.954,0.405-1.856,0.847-1.856,1.487c0,0.45,0.267,0.703,1.003,0.966 c0.766,0.273,2.695,0.858,3.834,1.172c1.097,0.303,2.346,0.04,3.046-0.395c0.742-0.461,9.305-6.191,9.92-6.693 c0.614-0.502,1.104,0.141,0.602,0.644c-0.502,0.502-6.38,6.207-7.155,6.997c-0.941,0.959-0.273,1.953,0.358,2.351 c0.721,0.454,5.906,3.932,6.687,4.49c0.781,0.558,1.573,0.811,2.298,0.811C32.191,36.439,32.573,35.484,32.934,34.375z'
                  fill='white'
                />
              </svg>
            </li>
            <li>
              <svg
                xmlns='http://www.w3.org/2000/svg'
                fill='none'
                viewBox='-10 -5 100 100'
                width='70px'
                height='50px'
              >
                <path
                  d='M 24.402344 9 C 17.800781 9 11.601563 9.5 8.300781 10.199219 C 6.101563 10.699219 4.199219 12.199219 3.800781 14.5 C 3.402344 16.898438 3 20.5 3 25 C 3 29.5 3.398438 33 3.898438 35.5 C 4.300781 37.699219 6.199219 39.300781 8.398438 39.800781 C 11.902344 40.5 17.898438 41 24.5 41 C 31.101563 41 37.097656 40.5 40.597656 39.800781 C 42.800781 39.300781 44.699219 37.800781 45.097656 35.5 C 45.5 33 46 29.402344 46.097656 24.902344 C 46.097656 20.402344 45.597656 16.800781 45.097656 14.300781 C 44.699219 12.101563 42.800781 10.5 40.597656 10 C 37.097656 9.5 31 9 24.402344 9 Z M 24.402344 11 C 31.601563 11 37.398438 11.597656 40.199219 12.097656 C 41.699219 12.5 42.898438 13.5 43.097656 14.800781 C 43.699219 18 44.097656 21.402344 44.097656 24.902344 C 44 29.199219 43.5 32.699219 43.097656 35.199219 C 42.800781 37.097656 40.800781 37.699219 40.199219 37.902344 C 36.597656 38.601563 30.597656 39.097656 24.597656 39.097656 C 18.597656 39.097656 12.5 38.699219 9 37.902344 C 7.5 37.5 6.300781 36.5 6.101563 35.199219 C 5.300781 32.398438 5 28.699219 5 25 C 5 20.398438 5.402344 17 5.800781 14.902344 C 6.101563 13 8.199219 12.398438 8.699219 12.199219 C 12 11.5 18.101563 11 24.402344 11 Z M 19 17 L 19 33 L 33 25 Z M 21 20.402344 L 29 25 L 21 29.597656 Z'
                  fill='white'
                />
              </svg>
            </li>
          </ul>
        </div>
        <div className={styles.flexboxContainer}>
          <ul>
            <li>
              <svg
                xmlns='http://www.w3.org/2000/svg'
                id='Layer_1'
                height='50'
                width='120'
                viewBox='-0 0 1350 800'
              >
                <title>Apple</title>
                <g id='Page-1'>
                  <g id='Artboard-1' transform='translate(-461 -850)'>
                    <g id='App-Store' transform='translate(462 850)'>
                      <path
                        id='background'
                        d='M59 0h1357c33.1 0 60 26.9 60 60v380c0 33.1-26.9 60-60 60H59c-33.1 0-60-26.9-60-60V60C-1 26.9 25.9 0 59 0z'
                      />
                      <g id='icon' transform='translate(130 88)'>
                        <path
                          id='Fill-2'
                          d='M192.3 150.6c-.3-35.8 29.3-53.2 30.6-54-16.8-24.4-42.8-27.8-51.9-28.1-21.8-2.3-43 13.1-54.1 13.1-11.3 0-28.5-12.8-46.9-12.5-23.7.4-46 14.1-58.1 35.5-25.1 43.5-6.4 107.5 17.7 142.7 12.1 17.2 26.1 36.5 44.6 35.8 18-.7 24.8-11.5 46.5-11.5 21.6 0 27.9 11.5 46.7 11.1 19.4-.3 31.5-17.3 43.2-34.7 13.9-19.7 19.5-39.2 19.7-40.2-.5-.2-37.6-14.4-38-57.2'
                          fill='#FFF'
                        />
                        <path
                          id='Fill-3'
                          d='M156.8 45.4c9.7-12.1 16.3-28.6 14.5-45.4-14 .6-31.6 9.7-41.7 21.6-8.9 10.5-16.9 27.6-14.9 43.7 15.8 1.2 32-8 42.1-19.9'
                          fill='#FFF'
                        />
                      </g>
                      <g transform='translate(459 218)'>
                        <path
                          id='Fill-4'
                          d='M124.5 150.6H99.3l-13.8-43.4h-48l-13.1 43.4H-.1L47.4 2.9h29.4l47.7 147.7zM81.4 89L68.9 50.5c-1.3-4-3.8-13.2-7.4-27.8H61c-1.5 6.3-3.8 15.6-7 27.8L41.7 89h39.7z'
                          fill='#FFF'
                        />
                        <path
                          id='Fill-5'
                          d='M246.6 96.1c0 18.1-4.9 32.4-14.8 42.9-8.8 9.4-19.8 14-32.8 14-14.1 0-24.2-5-30.4-15.1v55.9h-23.7V79.1c0-11.4-.3-23-.9-35h20.8l1.3 16.9h.4c7.9-12.7 19.9-19.1 35.9-19.1 12.6 0 23 5 31.4 14.9 8.6 10 12.8 23 12.8 39.3zm-24.1.8c0-10.4-2.3-18.9-7-25.6-5.1-7-12-10.5-20.6-10.5-5.8 0-11.1 2-15.9 5.8-4.7 3.9-7.9 8.9-9.3 15.2-.7 2.9-1.1 5.3-1.1 7.2v17.8c0 7.7 2.4 14.3 7.1 19.6 4.7 5.3 10.9 8 18.5 8 8.9 0 15.8-3.5 20.8-10.3 5-6.9 7.5-15.9 7.5-27.2z'
                          fill='#FFF'
                        />
                        <path
                          id='Fill-6'
                          d='M369 96.1c0 18.1-4.9 32.4-14.8 42.9-8.8 9.4-19.8 14-32.8 14-14.1 0-24.2-5-30.4-15.1v55.9h-23.7V79.1c0-11.4-.3-23-.9-35h20.8l1.3 16.9h.4c7.9-12.7 19.9-19.1 35.9-19.1 12.6 0 23 5 31.4 14.9 8.6 10 12.8 23 12.8 39.3zm-24.1.8c0-10.4-2.3-18.9-7-25.6-5.1-7-12-10.5-20.6-10.5-5.8 0-11.1 2-15.9 5.8-4.7 3.9-7.8 8.9-9.3 15.2-.7 2.9-1.1 5.3-1.1 7.2v17.8c0 7.7 2.4 14.3 7.1 19.6 4.7 5.3 10.9 8 18.5 8 8.9 0 15.9-3.5 20.8-10.3 5.1-6.9 7.5-15.9 7.5-27.2z'
                          fill='#FFF'
                        />
                        <path
                          id='Fill-7'
                          d='M506 109.2c0 12.6-4.4 22.8-13.1 30.7-9.6 8.6-23 12.9-40.2 12.9-15.9 0-28.6-3.1-38.2-9.2l5.5-19.7c10.4 6.1 21.8 9.2 34.2 9.2 8.9 0 15.9-2 20.8-6 5-4 7.5-9.4 7.5-16.1 0-6-2.1-11-6.1-15.1-4.1-4.1-10.9-7.9-20.4-11.4-26.1-9.7-39-23.8-39-42.3 0-12.1 4.6-22 13.7-29.8C439.8 4.7 451.9.8 467 .8c13.4 0 24.6 2.3 33.5 7l-6 19.2c-8.4-4.5-17.8-6.8-28.4-6.8-8.3 0-14.9 2.1-19.6 6.1-3.9 3.7-5.9 8.1-5.9 13.4 0 5.8 2.3 10.7 6.8 14.4 3.9 3.5 11.1 7.3 21.5 11.4 12.7 5.1 22 11.1 28 18 6.1 6.9 9.1 15.5 9.1 25.7'
                          fill='#FFF'
                        />
                        <path
                          id='Fill-8'
                          d='M584.4 61.9h-26.1v51.7c0 13.1 4.6 19.7 13.8 19.7 4.2 0 7.7-.4 10.5-1.1l.7 18c-4.7 1.7-10.8 2.6-18.4 2.6-9.4 0-16.6-2.9-21.9-8.6-5.3-5.7-7.9-15.3-7.9-28.7V61.8h-15.5V44.1h15.5V24.6l23.2-7v26.5h26.1v17.8'
                          fill='#FFF'
                        />
                        <path
                          id='Fill-9'
                          d='M701.8 96.5c0 16.4-4.7 29.8-14 40.3-9.8 10.8-22.8 16.2-39 16.2-15.6 0-28.1-5.2-37.4-15.5s-13.9-23.4-13.9-39.2c0-16.5 4.8-30 14.3-40.5 9.6-10.5 22.5-15.8 38.7-15.8 15.6 0 28.2 5.2 37.7 15.6 9.1 10 13.6 23 13.6 38.9zm-24.5.5c0-9.8-2.1-18.1-6.3-25.1-5-8.5-12.1-12.7-21.3-12.7-9.5 0-16.8 4.2-21.7 12.7-4.3 7-6.3 15.5-6.3 25.6 0 9.8 2.1 18.2 6.3 25.1 5.1 8.5 12.3 12.7 21.5 12.7 9 0 16.1-4.3 21.3-12.9 4.3-7.2 6.5-15.6 6.5-25.4z'
                          fill='#FFF'
                        />
                        <path
                          id='Fill-10'
                          d='M778.8 64.9c-2.3-.4-4.8-.6-7.5-.6-8.3 0-14.8 3.1-19.3 9.4-3.9 5.5-5.9 12.6-5.9 21v55.9h-23.7v-73c0-12.3-.2-23.5-.7-33.5h20.6l.9 20.4h.7c2.5-7 6.4-12.7 11.8-16.9 5.3-3.8 11-5.7 17.1-5.7 2.2 0 4.2.2 5.9.4l.1 22.6'
                          fill='#FFF'
                        />
                        <path
                          id='Fill-11'
                          d='M884.6 92.3c0 4.2-.3 7.8-.9 10.7h-71c.3 10.5 3.7 18.6 10.3 24.1 6 4.9 13.7 7.4 23.2 7.4 10.5 0 20.1-1.7 28.7-5l3.7 16.4c-10.1 4.4-22 6.6-35.7 6.6-16.5 0-29.5-4.9-38.9-14.6-9.4-9.7-14.1-22.8-14.1-39.1 0-16 4.4-29.4 13.2-40.1 9.2-11.4 21.6-17.1 37.2-17.1 15.3 0 27 5.7 34.8 17.1 6.3 9.2 9.5 20.3 9.5 33.6zM862 86.2c.2-7-1.4-13.1-4.6-18.2-4.1-6.6-10.4-9.9-18.8-9.9-7.7 0-14 3.2-18.8 9.6-3.9 5.1-6.3 11.3-7 18.4l49.2.1z'
                          fill='#FFF'
                        />
                      </g>
                      <g id='Available-on-the' transform='translate(468 91)'>
                        <path
                          id='Fill-12'
                          d='M61 77.1H48.6l-6.8-21.3H18.2l-6.5 21.3h-12L23 4.5h14.4L61 77.1zM39.7 46.8l-6.1-19c-.6-1.9-1.8-6.5-3.7-13.7h-.2c-.8 3.1-1.8 7.6-3.5 13.7l-6 19h19.5z'
                          fill='#FFF'
                        />
                        <path
                          id='Fill-13'
                          d='M119.4 24.7L99.6 77.1H88.3L69.1 24.7h12.5l8.9 27.7c1.5 4.6 2.8 9 3.8 13.2h.3c.9-3.8 2.2-8.2 3.8-13.2l8.8-27.7h12.2'
                          fill='#FFF'
                        />
                        <path
                          id='Fill-14'
                          d='M161.6 77.1l-.9-6h-.3c-3.6 4.8-8.7 7.2-15.3 7.2-9.4 0-16-6.6-16-15.4 0-12.9 11.2-19.6 30.6-19.6v-1c0-6.9-3.7-10.3-10.9-10.3-5.2 0-9.7 1.3-13.7 3.9l-2.4-7.6c4.8-3 10.9-4.5 18-4.5 13.7 0 20.6 7.2 20.6 21.7v19.3c0 5.3.2 9.4.8 12.5l-10.5-.2zM160 51c-12.9 0-19.4 3.1-19.4 10.6 0 5.5 3.3 8.2 8 8.2 5.9 0 11.4-4.5 11.4-10.7V51z'
                          fill='#FFF'
                        />
                        <path
                          id='Fill-15'
                          d='M197.2 16.1c-3.9 0-6.9-3-6.9-7s3.1-6.9 7.1-6.9c4 0 7.2 2.9 7.1 6.9 0 4.2-3 7-7.3 7zm-5.6 8.6h11.6V77h-11.6V24.7z'
                          fill='#FFF'
                        />
                        <path
                          id='Fill-16'
                          d='M223.9.7h11.6V77h-11.6V.7z'
                          fill='#FFF'
                        />

                        <path
                          id='Fill-17'
                          d='M284.9 77.1l-.9-6h-.3c-3.6 4.8-8.7 7.2-15.3 7.2-9.4 0-16-6.6-16-15.4 0-12.9 11.2-19.6 30.6-19.6v-1c0-6.9-3.7-10.3-10.9-10.3-5.2 0-9.7 1.3-13.7 3.9l-2.4-7.7c4.8-3 10.9-4.5 18-4.5 13.7 0 20.6 7.2 20.6 21.7v19.3c0 5.3.2 9.4.7 12.5h-10.4v-.1zM283.3 51c-12.9 0-19.4 3.1-19.4 10.6 0 5.5 3.3 8.2 8 8.2 5.9 0 11.4-4.5 11.4-10.7V51z'
                          fill='#FFF'
                        />
                        <path
                          id='Fill-18'
                          d='M341.8 78.3c-7.4 0-12.9-3.1-16.5-9.3h-.2l-.7 8.1h-9.9c.3-4.2.4-8.9.4-14.1V.7h11.7v31.7h.2c3.5-5.8 9-8.7 16.7-8.7 12.6 0 21.4 10.8 21.4 26.5 0 16.2-9.8 28.1-23.1 28.1zm-2.4-45.5c-6.7 0-12.8 5.8-12.8 13.9v9.2c0 7.2 5.5 13.1 12.6 13.1 8.7 0 13.9-7.1 13.9-18.4 0-10.6-5.4-17.8-13.7-17.8z'
                          fill='#FFF'
                        />
                        <path
                          id='Fill-19'
                          d='M382.1.7h11.6V77h-11.6V.7z'
                          fill='#FFF'
                        />
                        <path
                          id='Fill-20'
                          d='M457 53.7h-34.9c.2 9.9 6.8 15.5 16.5 15.5 5.2 0 9.9-.9 14.1-2.5l1.8 8.1C449.6 77 443.8 78 437 78c-16.4 0-26.1-10.3-26.1-26.4 0-16 9.9-28.1 24.8-28.1 13.3 0 21.8 9.9 21.8 24.9 0 2.1-.1 3.9-.5 5.3zm-10.6-8.3c0-8.1-4.1-13.8-11.5-13.8-6.7 0-11.9 5.8-12.7 13.8h24.2z'
                          fill='#FFF'
                        />
                        <path
                          id='Fill-21'
                          d='M527.5 78.3c-15.3 0-25.2-11.4-25.2-26.9 0-16.2 10.1-27.7 26.1-27.7 15.1 0 25.2 10.9 25.2 26.8 0 16.3-10.4 27.8-26.1 27.8zm.5-46.1c-8.4 0-13.8 7.9-13.8 18.8 0 10.8 5.5 18.6 13.7 18.6s13.7-8.4 13.7-18.9c-.1-10.6-5.4-18.5-13.6-18.5z'
                          fill='#FFF'
                        />
                        <path
                          id='Fill-22'
                          d='M616.1 77.1h-11.6V47c0-9.3-3.6-13.9-10.6-13.9-6.9 0-11.6 5.9-11.6 12.8V77h-11.6V39.7c0-4.6-.1-9.6-.4-15h10.2l.5 8.1h.3c3.1-5.6 9.5-9.2 16.6-9.2 11 0 18.2 8.4 18.2 22.1v31.4'
                          fill='#FFF'
                        />
                        <path
                          id='Fill-23'
                          d='M692.2 33.5h-12.8v25.4c0 6.5 2.3 9.7 6.8 9.7 2 0 3.8-.2 5.2-.5l.3 8.8c-2.3.9-5.3 1.3-9 1.3-9.2 0-14.6-5.1-14.6-18.3V33.5h-7.6v-8.7h7.6v-9.6l11.4-3.5v13h12.8v8.8'
                          fill='#FFF'
                        />
                        <path
                          id='Fill-24'
                          d='M753.8 77.1h-11.6V47.2c0-9.4-3.6-14.1-10.6-14.1-6 0-11.6 4.1-11.6 12.4V77h-11.6V.7H720v31.4h.2c3.7-5.7 8.9-8.5 15.7-8.5 11.1 0 17.9 8.6 17.9 22.3v31.2'
                          fill='#FFF'
                        />
                        <path
                          id='Fill-25'
                          d='M813.2 53.7h-34.9c.2 9.9 6.8 15.5 16.5 15.5 5.2 0 9.9-.9 14.1-2.5l1.8 8.1C805.8 77 800 78 793.2 78c-16.4 0-26.1-10.3-26.1-26.4 0-16 9.9-28.1 24.8-28.1 13.3 0 21.8 9.9 21.8 24.9 0 2.1-.1 3.9-.5 5.3zm-10.6-8.3c0-8.1-4.1-13.8-11.5-13.8-6.7 0-12 5.8-12.7 13.8h24.2z '
                          fill='#FFF'
                        />
                      </g>
                    </g>
                  </g>
                </g>
              </svg>
            </li>
            <li>
              <svg
                xmlns='http://www.w3.org/2000/svg'
                height='50'
                width='150'
                viewBox='0 -0 3000 1600'
              >
                <defs>
                  <linearGradient id='a' y2='.278' x2='.26' y1='.956' x1='.613'>
                    <stop offset='0%' stopColor='#00A0FF' />
                    <stop offset='.657%' stopColor='#00A1FF' />
                    <stop offset='26.01%' stopColor='#00BEFF' />
                    <stop offset='51.22%' stopColor='#00D2FF' />
                    <stop offset='76.04%' stopColor='#00DFFF' />
                    <stop offset='100%' stopColor='#00E3FF' />
                  </linearGradient>
                  <linearGradient
                    id='b'
                    y2='.509'
                    x2='-1.305'
                    y1='.509'
                    x1='1.076'
                  >
                    <stop offset='0%' stopColor='#FFE000' />
                    <stop offset='40.87%' stopColor='#FFBD00' />
                    <stop offset='77.54%' stopColor='orange' />
                    <stop offset='100%' stopColor='#FF9C00' />
                  </linearGradient>
                  <linearGradient
                    id='c'
                    y2='-.361'
                    x2='-.505'
                    y1='.691'
                    x1='.867'
                  >
                    <stop offset='0%' stopColor='#FF3A44' />
                    <stop offset='100%' stopColor='#C31162' />
                  </linearGradient>
                  <linearGradient
                    id='d'
                    y2='.649'
                    x2='.418'
                    y1='1.119'
                    x1='-.193'
                  >
                    <stop offset='0%' stopColor='#32A071' />
                    <stop offset='6.85%' stopColor='#2DA771' />
                    <stop offset='47.62%' stopColor='#15CF74' />
                    <stop offset='80.09%' stopColor='#06E775' />
                    <stop offset='100%' stopColor='#00F076' />
                  </linearGradient>
                  <linearGradient
                    id='e'
                    y2='-.021'
                    x2='-.501'
                    y1='.695'
                    x1='.862'
                  >
                    <stop offset='0%' stopColor='#CC2E36' />
                    <stop offset='100%' stopColor='#9C0E4E' />
                  </linearGradient>
                  <linearGradient
                    id='f'
                    y2='4.496'
                    x2='-.663'
                    y1='15.318'
                    x1='3.073'
                  >
                    <stop offset='0%' stopColor='#008DE0' />
                    <stop offset='.657%' stopColor='#008DE0' />
                    <stop offset='26.01%' stopColor='#00A7E0' />
                    <stop offset='51.22%' stopColor='#00B8E0' />
                    <stop offset='76.04%' stopColor='#00C4E0' />
                    <stop offset='100%' stopColor='#00C7E0' />
                  </linearGradient>
                  <linearGradient id='g' y2='1' x2='-2.882' y1='1' x1='1.128'>
                    <stop offset='0%' stopColor='#E0C500' />
                    <stop offset='40.87%' stopColor='#E0A600' />
                    <stop offset='77.54%' stopColor='#E09100' />
                    <stop offset='100%' stopColor='#E08900' />
                  </linearGradient>
                  <linearGradient id='h' y2='0' x2='-2.882' y1='0' x1='1.128'>
                    <stop offset='0%' stopColor='#FFE840' />
                    <stop offset='40.87%' stopColor='#FFCE40' />
                    <stop offset='77.54%' stopColor='#FFBC40' />
                    <stop offset='100%' stopColor='#FFB540' />
                  </linearGradient>
                  <linearGradient
                    id='i'
                    y2='-10.098'
                    x2='-.657'
                    y1='.234'
                    x1='3.061'
                  >
                    <stop offset='0%' stopColor='#40B8FF' />
                    <stop offset='.657%' stopColor='#40B9FF' />
                    <stop offset='26.01%' stopColor='#40CEFF' />
                    <stop offset='51.22%' stopColor='#40DDFF' />
                    <stop offset='76.04%' stopColor='#40E7FF' />
                    <stop offset='100%' stopColor='#40EAFF' />
                  </linearGradient>
                  <linearGradient
                    id='j'
                    y2='.537'
                    x2='.421'
                    y1='.856'
                    x1='-.188'
                  >
                    <stop offset='0%' stopColor='#65B895' />
                    <stop offset='6.85%' stopColor='#62BD95' />
                    <stop offset='47.62%' stopColor='#50DB97' />
                    <stop offset='80.09%' stopColor='#44ED98' />
                    <stop offset='100%' stopColor='#40F498' />
                  </linearGradient>
                  <linearGradient
                    gradientUnits='userSpaceOnUse'
                    gradientTransform='scale(.72167 1.38567)'
                    y2='110.924'
                    x2='103.763'
                    y1='380.413'
                    x1='243.89'
                    id='k'
                  />
                  <linearGradient
                    gradientUnits='userSpaceOnUse'
                    gradientTransform='scale(1.1083 .90228)'
                    y2='104.456'
                    x2='-265.185'
                    y1='104.456'
                    x1='219.82'
                    id='l'
                  />
                  <linearGradient
                    gradientUnits='userSpaceOnUse'
                    gradientTransform='scale(1.13894 .878)'
                    y2='-116.045'
                    x2='-162.26'
                    y1='222.803'
                    x1='279.815'
                    id='m'
                  />
                  <linearGradient
                    gradientUnits='userSpaceOnUse'
                    gradientTransform='scale(1.13896 .878)'
                    y2='210.03'
                    x2='134.984'
                    y1='361.335'
                    x1='-62.115'
                    id='n'
                  />
                  <linearGradient
                    gradientUnits='userSpaceOnUse'
                    gradientTransform='scale(1.38147 .72387)'
                    y2='-4.388'
                    x2='-133.972'
                    y1='187.683'
                    x1='231.994'
                    id='o'
                  />
                  <linearGradient
                    gradientUnits='userSpaceOnUse'
                    gradientTransform='scale(.58803 1.7006)'
                    y2='91.69'
                    x2='-13.255'
                    y1='311.274'
                    x1='62.549'
                    id='p'
                  />
                  <linearGradient
                    gradientUnits='userSpaceOnUse'
                    gradientTransform='scale(1.19442 .83723)'
                    y2='112.451'
                    x2='-322.924'
                    y1='112.451'
                    x1='127.112'
                    id='q'
                  />
                  <linearGradient
                    gradientUnits='userSpaceOnUse'
                    gradientTransform='scale(1.1944 .83724)'
                    y2='.829'
                    x2='-322.928'
                    y1='.829'
                    x1='127.114'
                    id='r'
                  />
                  <linearGradient
                    gradientUnits='userSpaceOnUse'
                    gradientTransform='scale(.58722 1.70294)'
                    y2='-204.589'
                    x2='-13.13'
                    y1='4.878'
                    x1='62.249'
                    id='s'
                  />
                  <linearGradient
                    gradientUnits='userSpaceOnUse'
                    gradientTransform='scale(1.38144 .72388)'
                    y2='144.927'
                    x2='113.528'
                    y1='230.7'
                    x1='-49.894'
                    id='t'
                  />
                </defs>
                <g fill='none'>
                  <path
                    fill='#000'
                    d='M2887.921 890.028H111.074C49.984 890.028 0 839.964 0 778.775V111.254C0 50.064 49.983 0 111.074 0H2887.92c61.09 0 111.074 50.064 111.074 111.254v667.52c0 61.19-49.983 111.254-111.074 111.254'
                  />
                  <path
                    fill='#A6A6A6'
                    d='M2887.921 0H111.074C49.984 0 0 50.064 0 111.254v667.52c0 61.19 49.983 111.254 111.074 111.254H2887.92c61.09 0 111.074-50.064 111.074-111.253V111.254C2998.995 50.064 2949.012 0 2887.92 0m0 17.8c51.45 0 93.302 41.93 93.302 93.454v667.52c0 51.534-41.853 93.463-93.302 93.463H111.074c-51.44 0-93.302-41.93-93.302-93.462V111.254c0-51.524 41.861-93.453 93.302-93.453H2887.92'
                  />
                  <path
                    fill='#FFF'
                    d='M1053.39 227.923c0 18.642-5.512 33.487-16.55 44.561-12.539 13.168-28.88 19.757-48.969 19.757-19.238 0-35.595-6.675-49.046-20.044-13.475-13.359-20.2-29.925-20.2-49.69 0-19.774 6.725-36.33 20.2-49.7 13.451-13.358 29.808-20.043 49.046-20.043 9.546 0 18.685 1.87 27.362 5.599 8.677 3.738 15.637 8.7 20.844 14.914l-11.716 11.742c-8.824-10.56-20.973-15.836-36.49-15.836-14.03 0-26.162 4.938-36.401 14.82-10.241 9.892-15.36 22.72-15.36 38.504 0 15.785 5.119 28.612 15.36 38.505 10.239 9.882 22.37 14.819 36.401 14.819 14.884 0 27.293-4.964 37.228-14.906 6.449-6.477 10.178-15.48 11.176-27.041H987.87v-16.036h64.59c.624 3.487.928 6.833.928 10.075'
                  />
                  <path
                    fill='#FFF'
                    d='M1053.39 227.923h-2.222c-.018 18.217-5.33 32.366-15.9 42.988l-.023.018-.01.018c-12.14 12.714-27.745 19.042-47.365 19.069-18.724-.027-34.397-6.424-47.484-19.392-13.058-12.994-19.515-28.857-19.54-48.117.025-19.269 6.482-35.123 19.54-48.108 13.087-12.977 28.76-19.383 47.484-19.41 9.26 0 18.077 1.81 26.485 5.416 8.417 3.634 15.066 8.396 20.02 14.308l1.701-1.436-1.57-1.573-11.716 11.75 1.57 1.565 1.711-1.424c-9.235-11.083-22.197-16.67-38.2-16.637-14.551-.018-27.351 5.19-37.939 15.447-10.69 10.29-16.061 23.84-16.043 40.102-.018 16.263 5.353 29.812 16.043 40.103 10.588 10.257 23.388 15.464 37.938 15.446 15.377.027 28.482-5.198 38.799-15.558 6.89-6.92 10.796-16.505 11.82-28.423l.207-2.416h-48.604v-11.586h62.368v-2.225l-2.188.391c.608 3.374.895 6.58.895 9.684h4.443c0-3.382-.313-6.858-.964-10.473l-.329-1.827H985.65v20.486h50.625v-2.225l-2.212-.191c-.98 11.196-4.539 19.627-10.535 25.66-9.545 9.525-21.26 14.226-35.657 14.253-13.51-.018-24.973-4.677-34.857-14.194-9.788-9.483-14.657-21.59-14.682-36.905.025-15.315 4.894-27.422 14.682-36.905 9.884-9.517 21.346-14.176 34.857-14.194 15.022.036 26.365 5.007 34.791 15.046l1.562 1.86 13.424-13.463 1.44-1.442-1.311-1.558c-5.458-6.517-12.73-11.69-21.668-15.53-8.955-3.852-18.405-5.782-28.238-5.782-19.749-.017-36.792 6.936-50.616 20.696-13.875 13.733-20.869 30.995-20.85 51.272-.019 20.268 6.975 37.54 20.859 51.281 13.815 13.751 30.858 20.696 50.607 20.678 20.567.018 37.628-6.824 50.575-20.444l-1.607-1.538 1.571 1.574c11.507-11.517 17.216-27.075 17.201-46.135h-2.222m102.395-55.767h-60.7v42.33h54.74v16.042h-54.74v42.33h60.7v16.401h-77.812V155.755h77.812v16.401'
                  />
                  <path
                    fill='#FFF'
                    d='M1155.784 172.156v-2.225h-62.921v46.78h54.739v11.586l-54.74.006v46.78h60.7v11.951h-73.368V157.98h73.368v14.176h2.222v-2.225 2.225h2.221V153.53h-82.254v137.954h82.254v-20.851h-60.7v-37.88h54.74v-20.492h-54.74v-37.88h60.7v-2.225h-2.221m72.224 117.104h-17.138V172.155h-37.228v-16.401h91.594v16.401h-37.228v117.103'
                  />
                  <path
                    fill='#FFF'
                    d='M1228.008 289.26v-2.226h-14.917V169.931h-37.227v-11.95h87.15v11.95h-37.227v119.328h2.221v-2.225 2.225h2.222V174.381h37.227V153.53h-96.036v20.85h37.227v117.103h21.582v-2.225h-2.222m103.499.002V155.754h17.121v133.504h-17.121'
                  />
                  <path
                    fill='#FFF'
                    d='M1331.507 289.26h2.222V157.98h12.677v129.054h-14.899v2.225h2.222-2.222v2.225h19.342V153.53h-21.563v137.954h2.221v-2.225m93.093.001h-17.138V172.155h-37.226v-16.401h91.592v16.401H1424.6v117.103'
                  />
                  <path
                    fill='#FFF'
                    d='M1424.6 289.26v-2.226h-14.917V169.931h-37.225v-11.95h87.148v11.95h-37.227v119.328h2.221v-2.225 2.225h2.222V174.381h37.227V153.53h-96.034v20.85h37.225v117.103h21.582v-2.225h-2.222m125.532-28.428c9.865 10.003 21.937 15 36.212 15 14.275 0 26.353-4.997 36.203-15 9.875-10.004 14.822-22.792 14.822-38.323 0-15.53-4.947-28.318-14.822-38.322-9.85-10.004-21.928-15.002-36.203-15.002-14.275 0-26.347 4.998-36.212 15.002-9.85 10.004-14.795 22.791-14.795 38.322 0 15.531 4.945 28.319 14.795 38.323zm85.084 11.176c-13.104 13.497-29.4 20.235-48.872 20.235-19.491 0-35.78-6.738-48.855-20.235-13.113-13.482-19.638-29.985-19.638-49.499 0-19.514 6.525-36.02 19.638-49.499 13.076-13.5 29.364-20.244 48.855-20.244 19.369 0 35.621 6.78 48.786 20.331 13.146 13.55 19.724 30.02 19.724 49.412 0 19.514-6.562 36.017-19.638 49.499z'
                  />
                  <path
                    fill='#FFF'
                    d='M1550.132 260.83l-1.58 1.564c10.232 10.404 22.997 15.689 37.792 15.662 14.786.027 27.568-5.258 37.783-15.662 10.299-10.414 15.479-23.886 15.463-39.887.015-16-5.164-29.473-15.463-39.887-10.215-10.404-22.997-15.688-37.783-15.662-14.795-.026-27.56 5.258-37.792 15.662-10.274 10.414-15.464 23.887-15.437 39.887-.027 16 5.163 29.473 15.437 39.887l1.58-1.564 1.58-1.565c-9.424-9.605-14.136-21.687-14.154-36.758.018-15.07 4.73-27.152 14.153-36.758 9.51-9.603 20.869-14.314 34.633-14.34 13.753.026 25.138 4.737 34.624 14.34 9.441 9.606 14.153 21.688 14.17 36.758-.017 15.07-4.729 27.153-14.17 36.758-9.486 9.604-20.87 14.314-34.624 14.34-13.764-.026-25.123-4.736-34.633-14.34zm85.084 11.176l-1.588-1.546c-12.738 13.072-28.315 19.53-47.284 19.556-18.978-.027-34.555-6.484-47.269-19.556l-.06-.07.06.07c-12.711-13.117-18.984-28.935-19.002-47.953.018-19.018 6.291-34.836 19.002-47.952 12.714-13.073 28.29-19.539 47.269-19.565 18.847.026 34.388 6.519 47.197 19.66 12.756 13.177 19.065 28.97 19.092 47.857-.027 19.018-6.318 34.836-19.005 47.953l1.588 1.546 1.598 1.546c13.466-13.853 20.277-31.037 20.262-51.045.016-19.894-6.822-37.043-20.351-50.958-13.536-13.97-30.492-21.034-50.381-21.01-19.993-.024-37.001 7.007-50.452 20.923v-.01c-13.493 13.863-20.28 31.047-20.262 51.055-.018 20.008 6.769 37.192 20.262 51.054l.06.063-.06-.072c13.451 13.916 30.459 20.932 50.452 20.914 19.984.018 36.992-6.998 50.47-20.914l-1.598-1.546zm43.674 17.254V155.754h20.845l64.778 103.857h.738l-.738-25.728v-78.129h17.139v133.504h-17.877l-67.772-108.89h-.738l.738 25.737v83.153h-17.112'
                  />
                  <path
                    fill='#FFF'
                    d='M1678.89 289.26h2.222V157.98h17.39l64.778 103.857h4.252l-.798-27.986v-75.87h12.696v129.053h-14.422l-67.772-108.89h-4.252l.797 27.998v80.892h-14.89v2.225h2.221-2.221v2.225h19.333v-85.413l-.737-25.762-2.222.06v2.225h.738v-2.225l-1.884 1.183 68.424 109.932h21.33V153.53h-21.581v80.38l.737 25.762 2.222-.06v-2.225h-.738v2.225l1.884-1.181-65.432-104.901h-24.295v137.954h2.222v-2.225m696.668 378.262h41.452v-278.16h-41.453zm373.363-177.96l-47.517 120.596h-1.422l-49.317-120.597h-44.652l73.953 168.556-42.163 93.758h43.252l113.962-262.314zm-235.077 146.367c-13.595 0-32.522-6.798-32.522-23.624 0-21.47 23.592-29.7 43.94-29.7 18.24 0 26.792 3.936 37.877 9.31-3.221 25.761-25.37 44.014-49.295 44.014zm4.999-152.453c-30.013 0-61.091 13.245-73.953 42.59l36.787 15.384c7.864-15.384 22.504-20.4 37.877-20.4 21.437 0 43.23 12.89 43.585 35.793v2.86c-7.509-4.295-23.57-10.735-43.23-10.735-39.653 0-80.04 21.824-80.04 62.623 0 37.219 32.523 61.198 68.955 61.198 27.88 0 43.23-12.525 52.893-27.195h1.422v21.468h40.009V560.413c0-49.376-36.788-76.938-84.305-76.938zm-256.181 39.946h-58.958v-95.346h58.958c30.99 0 48.584 25.7 48.584 47.672 0 21.556-17.595 47.674-48.584 47.674zm-1.066-134.06h-99.323v278.16h41.43V562.135h57.893c45.94 0 91.102-33.316 91.102-86.388 0-53.07-45.162-86.386-91.102-86.386zm-541.619 246.618c-28.637 0-52.613-24.015-52.613-57 0-33.331 23.976-57.712 52.613-57.712 28.273 0 50.461 24.38 50.461 57.712 0 32.985-22.188 57-50.46 57zm47.597-130.843h-1.432c-9.302-11.11-27.205-21.147-49.748-21.147-47.242 0-90.543 41.58-90.543 94.99 0 53.055 43.3 94.279 90.543 94.279 22.543 0 40.446-10.04 49.748-21.504h1.432v13.62c0 36.211-19.324 55.567-50.46 55.567-25.41 0-41.158-18.288-47.607-33.699l-36.14 15.055c10.378 25.092 37.937 55.923 83.747 55.923 48.672 0 89.83-28.684 89.83-98.582V489.725h-39.37zm67.998 162.385h41.515v-278.17h-41.515zm102.716-91.766c-1.075-36.567 28.273-55.202 49.386-55.202 16.474 0 30.425 8.24 35.068 20.08zm128.84-31.543c-7.865-21.156-31.857-60.223-80.887-60.223-48.672 0-89.11 38.355-89.11 94.634 0 53.055 40.082 94.635 93.762 94.635 43.312 0 68.37-26.528 78.745-41.939l-32.212-21.512c-10.73 15.776-25.413 26.172-46.533 26.172-21.113 0-36.141-9.682-45.81-28.675l126.332-52.34zm-1006.512-31.186v40.147h95.912c-2.863 22.582-10.379 39.07-21.833 50.542-13.953 13.985-35.785 29.396-74.08 29.396-59.053 0-105.217-47.675-105.217-106.822 0-59.146 46.164-106.827 105.218-106.827 31.854 0 55.11 12.549 72.291 28.68l28.273-28.316c-23.976-22.947-55.832-40.511-100.564-40.511-80.886 0-148.884 65.96-148.884 146.974 0 81.015 67.998 146.969 148.884 146.969 43.665 0 76.588-14.332 102.352-41.224 26.485-26.528 34.72-63.806 34.72-93.914 0-9.327-.713-17.923-2.153-25.094zm246.115 122.953c-28.637 0-53.333-23.66-53.333-57.356 0-34.055 24.696-57.356 53.333-57.356 28.626 0 53.322 23.301 53.322 57.356 0 33.697-24.696 57.356-53.322 57.356zm0-151.99c-52.258 0-94.848 39.788-94.848 94.634 0 54.488 42.59 94.635 94.848 94.635 52.247 0 94.837-40.147 94.837-94.635 0-54.846-42.59-94.634-94.837-94.634zm206.89 151.99c-28.625 0-53.324-23.66-53.324-57.356 0-34.055 24.699-57.356 53.325-57.356 28.628 0 53.324 23.301 53.324 57.356 0 33.697-24.696 57.356-53.324 57.356zm0-151.99c-52.255 0-94.836 39.788-94.836 94.634 0 54.488 42.581 94.635 94.837 94.635 52.249 0 94.84-40.147 94.84-94.635 0-54.846-42.591-94.634-94.84-94.634z'
                  />
                  <path
                    fill='#fff'
                    d='M233.446 169.357c-7.455 6.737-11.905 17.974-11.905 32.89v-3.372 492.21-3.242c0 13.775 3.817 24.413 10.281 31.264l1.65 1.582v.007c5.232 4.729 11.941 7.24 19.63 7.232 7.513 0 15.966-2.399 24.887-7.465l322.452-183.508 110.76-63.041c14.067-8.004 21.964-18.33 23.284-28.848v-.043c-1.32-10.542-9.217-20.86-23.283-28.865l-110.77-63.033L277.99 169.617c-8.94-5.075-17.399-7.483-24.932-7.483-7.68 0-14.38 2.503-19.61 7.223z'
                  />
                  <path
                    d='M12.047.234l-1.651 1.582C3.932 8.666.115 19.305.115 33.08v-3.242 492.088-3.25c0 14.916 4.45 26.153 11.905 32.89l275.237-275.675L12.047.234'
                    fill='url(#k)'
                    transform='matrix(1 0 0 -1 221.426 720.923)'
                  />
                  <path
                    d='M92.444.738L.686 92.66l91.75 91.907 110.769-63.032c14.066-8.006 21.963-18.323 23.283-28.866v-.042c-1.32-10.518-9.217-20.845-23.283-28.848L92.445.739'
                    fill='url(#l)'
                    transform='matrix(1 0 0 -1 507.997 537.692)'
                  />
                  <path
                    d='M20.068.12C12.38.113 5.671 2.625.44 7.353v.007l275.21 275.657 91.758-91.922L44.955 7.586C36.034 2.519 27.581.12 20.068.12'
                    fill='url(#m)'
                    transform='matrix(1 0 0 -1 233.034 728.048)'
                  />
                  <path
                    d='M275.428.707L.19 276.382c5.232 4.72 11.932 7.223 19.611 7.223 7.533 0 15.993-2.407 24.932-7.483L367.177 92.614 275.427.707'
                    fill='url(#n)'
                    transform='matrix(1 0 0 -1 233.255 445.74)'
                  />
                  <path
                    d='M22.077.861c-7.688 0-14.406 2.512-19.638 7.24l-.009-.008a.635.635 0 01-.069.06L.93 9.553c-.045.044-.087.095-.14.146l1.65 1.653c5.232-4.728 11.94-7.24 19.63-7.231 7.512 0 15.965 2.398 24.886 7.465l322.452 183.508 2.066-2.07-2.092-1.19L46.955 8.336C38.825 3.72 31.092 1.313 24.107.912a41.848 41.848 0 00-2.03-.05'
                    fill='url(#o)'
                    transform='matrix(1 0 0 -1 231.034 732.048)'
                  />
                  <path
                    d='M10.396.799C3.932 7.649.115 18.279.115 32.063v3.242c0-13.775 3.817-24.413 10.281-31.264l1.65-1.582-1.65-1.66'
                    fill='url(#p)'
                    transform='matrix(1 0 0 -1 221.426 723.148)'
                  />
                  <path
                    d='M2.708.169L.642 2.239l110.76 63.04c14.067 8.003 21.964 18.33 23.284 28.848 0-3.86-.86-7.719-2.568-11.475-3.446-7.57-10.352-14.723-20.715-20.624L2.708.168'
                    fill='url(#q)'
                    transform='matrix(1 0 0 -1 599.799 539.192)'
                  />
                  <path
                    d='M134.686.716c-1.32 10.543-9.217 20.86-23.283 28.866L.633 92.614l2.066 2.07h.009l108.695-61.86c15.508-8.831 23.274-20.468 23.283-32.108'
                    fill='url(#r)'
                    transform='matrix(1 0 0 -1 599.799 445.74)'
                  />
                  <path
                    d='M.115.234v3.4c0 1.226.033 2.425.096 3.589v.053c0 .016 0 .033.006.051v.131c.669 11.865 4.348 21.12 10.179 27.3l1.624-1.633C4.565 26.387.115 15.15.115.234'
                    fill='url(#s)'
                    transform='matrix(1 0 0 -1 221.426 202.481)'
                  />
                  <path
                    d='M369.398.66L46.955 184.17c-8.939 5.075-17.398 7.482-24.931 7.482-7.68 0-14.38-2.503-19.611-7.223l-1.624 1.634a29.747 29.747 0 001.58 1.555c.017.018.044.036.061.053 5.19 4.684 11.819 7.187 19.43 7.232h.164c7.533 0 15.992-2.408 24.931-7.485L371.473 2.737l-.009-.007-2.066-2.07'
                    fill='url(#t)'
                    transform='matrix(1 0 0 -1 231.034 353.786)'
                  />
                </g>
              </svg>
            </li>
          </ul>
        </div>
        <div>
          <div className={styles.flexboxContainer}>
            <div
              style={{
                fontSize: '50px',
                marginRight: '25px',
                marginTop: '-16px',
              }}
            >
              <svg
                xmlns='http://www.w3.org/2000/svg'
                width='60px'
                height='50px'
                viewBox='0 0 400 50'
                version='1.1'
              >
                <title>mir-logo</title>
                <desc>Created with Sketch.</desc>
                <defs>
                  <linearGradient
                    x1='100%'
                    y1='62.9043048%'
                    x2='0%'
                    y2='62.9043048%'
                    id='linearGradient-1'
                  >
                    <stop stopColor='#1F5CD7' offset='0%' />
                    <stop stopColor='#02AEFF' offset='100%' />
                  </linearGradient>
                </defs>
                <g
                  id='sim'
                  stroke='none'
                  strokeWidth='1'
                  fill='none'
                  fillRule='evenodd'
                >
                  <g id='mir-logo' transform='translate(31.000000, 13.000000)'>
                    <g id='Group-5'>
                      <path
                        d='M32.5505663,0.0163847792 C35.6952917,-0.00242815539 45.0412371,-0.844175419 49,12.5166493 C51.6666667,21.5166493 55.9145075,36.259066 61.7435225,56.7438993 L61.7435225,56.7438993 L64.1174373,56.7438993 C70.3685427,35.1473512 74.6627303,20.4049345 77,12.5166493 C81,-0.983350676 91,0.0166493236 95,0.0166493236 L125.86096,0.0166878181 L125.86096,96.0164413 L94.4066344,96.0164413 L94.4066344,39.4421872 L92.2973975,39.4421872 L74.7631716,96.0164413 L51.0977882,96.0164413 L33.5635623,39.4002658 L31.4543254,39.4002658 L31.4543254,96.0164413 L0,96.0164413 L0,0.0166878181 Z M171.028726,0.0166878181 L171.028726,56.6330713 L173.537996,56.6330713 L194.866787,10.0778192 C199.007082,0.813194049 207.831347,0.0166878181 207.831347,0.0166878181 L207.831347,0.0166878181 L238.269736,0.0166878181 L238.269736,96.0166493 L206.158501,96.0166493 L206.158501,39.4002658 L203.649231,39.4002658 L182.738651,85.955518 C178.598356,95.1782217 169.35588,96.0166493 169.35588,96.0166493 L138.917491,96.0166493 L138.917491,0.0166878181 L171.028726,0.0166878181 Z M349.260509,45.6365042 C344.781335,58.3294446 330.714922,67.4197682 315.141489,67.4197682 L315.141489,67.4197682 L281.466507,67.4197682 L281.466507,96.0166493 L250.930615,96.0166493 L250.930615,45.6365042 Z'
                        id='Combined-Shape'
                        fill='#fff'
                      />
                      <path
                        d='M316.614216,0.0166878181 L249.329298,0.0166878181 C250.930615,21.3895399 269.336373,39.6860934 288.390129,39.6860934 L351.3823,39.6860934 C355.0174,21.922741 342.503442,0.0166878181 316.614216,0.0166878181 Z'
                        id='path24'
                        fill='#fff'
                      />
                    </g>
                  </g>
                </g>
              </svg>
            </div>
            <div style={{ marginRight: '25px' }}>
              <SiVisa size={50} />
            </div>
            <div>
              <SiMastercard size={40} />
            </div>
          </div>
        </div>
      </div>

      <div id='lowerFooter' className={styles.lowerFooter}>
        Войди или зарегистрируйся, чтобы получить скидку по программе лояльности
      </div>
    </>
  )
}

export default Footer
